<template>
  <div>
    <div class="prizes__carousel">
      <div class="prizes__carousel__dots">
        <div v-if="prizes[0].activeFrom !== ''" :class="['owl-dot']"><span></span>
          <div v-if ="(type === 'DAILY')" class="desc">{{ getDayofWeek(prizes[0]) }}<br>{{ getDateFormat(prizes[0].activeFrom,'D MMM') }}<div v-if="type !== 'DAILY'">{{ getDateFormat(prizes[0].activeTo,'D MMM') }}</div></div>
          <div v-else class="desc">{{ getDateFormat(prizes[0].activeFrom,'D MMM') }} - {{ getDateFormat(prizes[0].activeTo,'D MMM') }}</div>
        </div>
        <div v-if="prizes[1].activeFrom !== ''" :class="['owl-dot']"><span></span>
          <div v-if ="(type === 'DAILY')" class="desc">{{ getDayofWeek(prizes[1]) }}<br>{{ getDateFormat(prizes[1].activeFrom,'D MMM') }}<div v-if="type !== 'DAILY'">{{ getDateFormat(prizes[1].activeTo,'D MMM')  }}</div></div>
          <div v-else class="desc">{{ getDateFormat(prizes[1].activeFrom,'D MMM') }} - {{ getDateFormat(prizes[1].activeTo,'D MMM') }}</div>
        </div>
        <div v-if="prizes[2].activeFrom !== ''" :class="['owl-dot']"><span></span>
          <div v-if ="(type === 'DAILY')" class="desc">{{ getDayofWeek(prizes[2]) }}<br>{{ getDateFormat(prizes[2].activeFrom,'D MMM') }}</div>
          <div v-else class="desc">{{ getDateFormat(prizes[2].activeFrom,'D MMM') }} - {{ getDateFormat(prizes[2].activeTo,'D MMM') }}</div>
        </div>
      </div>
      <div :class="[(getNumberOfItems() !== 1) ? 'owl-carousel' : '', 'prizes-carousel', 'generic-carousel']">
        <div :class="['list_item', type.toLowerCase()]" v-if="prizes[0].imgUrl">
          <div class="lead_prize_box">
            <img :src="prizes[0].imgUrl" alt="">
            <h1>{{ getTranslationBasedOnType(type.toLowerCase()) }}</h1>
            <p>{{ prizes[0].headline }}</p>
          </div>
        </div>
        <div :class="['list_item', type.toLowerCase()]" v-if="prizes[1].imgUrl">
          <div class="lead_prize_box">
            <img :src="prizes[1].imgUrl" alt="">
            <h1>{{ getTranslationBasedOnType(type.toLowerCase()) }}</h1>
            <p>{{ prizes[1].headline }}</p>
          </div>
        </div>
        <div :class="['list_item', type.toLowerCase()]" v-if="getNumberOfItems() !== 1 && prizes[2].imgUrl">
          <div class="lead_prize_box">
            <img :src="prizes[2].imgUrl" alt="">
            <h1>{{ getTranslationBasedOnType(type.toLowerCase()) }}</h1>
            <p>{{ prizes[2].headline }}</p>
          </div>
        </div>
        <div v-else :class="['list_item', type.toLowerCase()]">
          <div class="lead_prize_box">
            <img :src="prizes[2].imgUrl" alt="">
            <h1>{{ getTranslationBasedOnType(type.toLowerCase()) }}</h1>
            <p>{{ prizes[2].headline }}</p>
          </div>
        </div>
      </div>
      <div class="carousel__nav"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'date-tab',
  props: ['type', 'getDateFormat', 'prizes'],
  methods: {
    getTranslationBasedOnType(type) {
      if (type === 'weekly') return this.getTranslations.home_modals_prize_details_weekly_prize;
      else if (type === 'daily') return this.getTranslations.home_modals_prize_details_daily_prize;
      else if (type === 'grand') return this.getTranslations.home_modals_prize_details_grand_prize;
      else if (type === 'monthly') return this.getTranslations.home_modals_prize_details_monthly_prize;
      return '';
    },
    getDayofWeek(dayOfweek) {
      return this.getDateFormat(dayOfweek.activeFrom, 'ddd');
    },
    getNumberOfItems() {
      this.$emit('initCarousel');
      return this.prizes.filter(item => item.imgUrl).length;
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/DateTab.vue